export {LoginPage}    from './LoginPage';
export {AuthRegister} from "./AuthRegister";


